import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { addStandardPVAs } from "store/reducers/products/parameters/parameters.actions";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import { ActionButtonConfirmStatus } from "components";
import { ProcessState } from "types/process";

export default function StandardPVAButton() {
  const [processState, setProcessState] = useState<ProcessState>(
    ProcessState.IDLE
  );
  const [statusMessage, setStatusMessage] = useState<string>("");

  const dispatch = useDispatch();

  const resetDialogState = useCallback(() => {
    setProcessState(ProcessState.IDLE);
    setStatusMessage("");
  }, []);

  const handleAddStandardPVAs = async () => {
    setProcessState(ProcessState.PROCESSING);
    setStatusMessage("Creating Standard PVAs");

    dispatch(addStandardPVAs());

    setProcessState(ProcessState.COMPLETE);
    setStatusMessage("All standard PVAs created!");
  };

  return (
    <ActionButtonConfirmStatus
      //Button Props
      variant="outlined"
      color="secondary"
      //Icon props
      icon={BuildCircleIcon}
      iconOnly={false}
      //Tooltip props
      tooltipText="Create any standard property value attributes not already added to this product line"
      tooltipArrow={true}
      tooltipPlacement="right"
      //Dialog Props
      maxWidth="sm"
      fullWidth
      dialogTitle="Create Standard Attributes"
      onDialogOpen={resetDialogState}
      disableEscapeKeyDown={true}
      disableCloseOnBackdropClick={true}
      //Content Section Props
      contentSection={
        "Are you sure you want to create all standard Property Value Attributes?"
      }
      hideContentOnProcessComplete={true}
      //Action Button Props
      defaultButton="CANCEL"
      cancelButtonText="Cancel"
      okButtonText="OK"
      okButtonWarningColor={false}
      onOKButtonClick={handleAddStandardPVAs}
      //Status Section Props
      processState={processState}
      statusMessage={statusMessage}
      //Result Section Props
      resultSection={undefined}
    >
      Create Standard Attributes
    </ActionButtonConfirmStatus>
  );
}
